import { toast } from "react-toastify";
import { setTitle } from "../../../../helpers/MetaTag";
import { handleFilterChange } from "../../../../helpers";
import DeleteModal from "../../../../components/common/DeleteModal";

import { useDebounce } from "../../../../hooks/useDebounce";
import LimitSelect from "../../../../components/elements/LimitSelect";
import { useState } from "react";
import Search from "../../../../components/form/Search";
import Table from "../../../../components/elements/table/Table";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Button from "../../../../components/form/Button";
import {
  orderDelete,
  orderList,
  orderOrdering,
  orderStatusChange,
} from "../../../../services/orderService";
import ManageOrderDrawer from "../../../../components/sections/front/Order/Drawer/ManageOrderDrawer";
import dayjs from "dayjs";
import ActionBar from "../../../../components/elements/ActionBar";
import { lngDetect } from "../../../../helpers/lngDetect";
import Badge from "../../../../components/elements/Badge";
import { tableFilter } from "../../../../helpers/tableFilterOptions";
import { userList } from "../../../../services/userService";
import DatePicker from "../../../../components/form/DatePicker";
import { eventList } from "../../../../services/eventService";
import Select from "../../../../components/form/select/Select";
import PopoverDropdown from "../../../../components/elements/PopoverDropdown";
import { useOrganization } from "../../../../context/OrganizationContext";
import { useSelector } from "react-redux";
import Modal from "../../../../components/elements/Modal";
import { t } from "i18next";

const Earnings = () => {
  const { selectedOrganizationDetails } = useSelector(
    (state) => state?.organization
  );
  const user_role = selectedOrganizationDetails?.data?.verificationData?.role;
  const [selectedItems, setSelectedItems] = useState([]);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [statusModal, setStatusModal] = useState({
    isOpen: false,
    data: null,
  });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const [eventkeyword, seteventKeyword] = useState("");
  const eventsearch = useDebounce(eventkeyword, 300);
  const queryClient = useQueryClient();
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });
  const [eventfilters, setEventFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "ordering",
  });

  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["order", filters, search],
    queryFn: async () => {
      const res = await orderList({
        viewAs: "promoter",
        ...filters,
        ...(search && { keyword: search }),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  const {
    data: eventData,
    isLoading: eventLoading,
    isFetching: eventFetching,
  } = useQuery({
    queryKey: ["Event", eventfilters, eventsearch],
    queryFn: async () => {
      const res = await eventList({
        ...eventfilters,
        ...(eventsearch && { keyword: eventsearch }),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  const tableHeadData = [
    {
      _id: "OrderId",
      name: t("Order Id"),
      align: "left",
    },
    {
      _id: 1,
      name: t("Earning Amount"),
      align: "left",
    },
    {
      _id: 2,
      name: "Event Name",
      align: t("left"),
      ...tableFilter({
        filterKey: "event",
        filters,
        setFilters: (val) => {
          setFilters((pre) => ({ ...pre, ...val, page: 1 }));
        },
        filterSearch: seteventKeyword,
        // onFilterScroll: (e) => {
        //   console.log(e);
        // },
        isFilterSearch: true,
        filterList: eventData?.data?.map((item) => ({
          name: lngDetect(item?.title),
          value: item?._id,
          type: "checkbox",
        })),
      }),
    },
    {
      _id: 3,
      name: t("Order by"),
      align: "left",
    },
    {
      _id: 4,
      name: t("Order date"),
      align: "left",
    },
  ];

  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 1,
          type: "text",
          align: "left",
          cellClass: "!min-w-[200px]",
          data: item?.orderId || "-",
        },
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[200px]",
          data: item?.promoterInfo?.promoterFee ? (
            <span>$ {item?.promoterInfo?.promoterFee}</span>
          ) : (
            "-"
          ),
        },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[200px]",
          data: lngDetect(item?.eventData?.title) || "-",
        },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[200px]",
          data:
            (item?.userData?.firstName ?? "") +
            " " +
            (item?.userData?.lastName ?? ""),
        },
        {
          _id: 5,
          type: "text",
          align: "left",
          cellClass: "!min-w-[200px]",
          data: dayjs(item?.date).format("MMM DD, YYYY") || "-",
        },
      ],
    };
  });

  const options = [
    {
      id: "userDelete",
      icon: "fa-regular fa-trash-can",
      tooltip: "User Delete",
    },
  ];

  function actionHandler(val) {
    switch (val) {
      case "userDelete":
        setDeleteModal({
          isOpen: true,
          data: { _id: selectedItems },
        });
        break;

      default:
        break;
    }
  }

  const { mutate: handleOrdering, isPending } = useMutation({
    mutationFn: async ({ newData, oldData }) => {
      const res = await orderOrdering({
        ordering_data: newData?.map((item, i) => ({
          id: item?._id,
          ordering: i,
        })),
      });
      return { res, newData, oldData };
    },
    onSuccess: ({ res, newData, oldData }) => {
      if (res?.status !== 200) {
        queryClient.setQueryData(["order", filters, search], (state) => {
          if (state) {
            return { ...state, data: oldData };
          }
        });
        toast.warning(res?.message || res?.error);
      }
    },
  });

  return (
    <div className="max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl w-full mx-auto relative space-y-10 py-10">
      <div className="space-y-8 md:py-8 px-5">
        <div className="flex justify-between items-center border-b border-gray-300">
          <div className="flex flex-col gap-2 w-full">
            <div className="font-bold text-lg xl:text-2xl uppercase tracking-tighter font-Montserrat">
              {t("Earnings")}
            </div>
            <div className="text-sm xl:text-base h-10">
              {t("Easily check all earnings info, status, etc")}
            </div>
          </div>
        </div>
        <div className="flex items-center justify-end gap-3">
          <div className="w-36">
            <LimitSelect
              value={filters?.limit}
              allValue={data?.metadata?.totalDocs}
              onChange={(val) => handleFilterChange("limit", val, setFilters)}
            />
          </div>
          <div className="relative">
            <Search
              placeholder={t("Search here")}
              divClasses={"!border-slate-300 !bg-slate-50 mb-0"}
              search={(val) => {
                setKeyword(val);
                handleFilterChange("page", 1, setFilters);
              }}
            />
          </div>
          {selectedItems?.length > 0 && (
            <div className="flex items-center gap-2">
              <ActionBar options={options} onChange={actionHandler} />
              <span className="flex items-center rounded-full bg-secondary text-surface-01 text-xs px-3 py-1 gap-2">
                {selectedItems?.length} {t("Selected")}
                <button
                  onClick={() => setSelectedItems([])}
                  type="button"
                  className="cursor-pointer"
                >
                  <i className="fa-fw fa-light fa-xmark"></i>
                </button>
              </span>
            </div>
          )}
        </div>
        <Table
          tableHeadData={tableHeadData}
          tableData={tableData}
          isLoder={isLoading}
          pageCount={data?.metadata?.totalPages}
          currentPage={filters?.page}
          onPageChange={(val) => {
            handleFilterChange("page", val, setFilters);
            setSelectedItems([]);
          }}
          originalData={[...(data?.data || [])]}
          setOriginalData={(val) => {
            queryClient.setQueryData(["order", filters, search], (state) => {
              if (state) {
                return { ...state, data: val };
              }
            });
          }}
          handleOrdering={(newData, oldData) =>
            handleOrdering({ newData, oldData })
          }
          //   isOrderingDisabled={false}
          isFetching={isFetching}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          tableActionDropdownContainer={"!w-48"}
          // selectable
        />
      </div>
    </div>
  );
};

export default Earnings;
